import React from 'react';
import { Container } from 'styles/Styles.styled';
import DynamicContentRenderer from '../DynamicContentRenderer';

interface Props {
  pages: any;
}

const PdfRootRenderer: React.FC<Props> = ({ pages }) => {
  return (
    <Container>
      <DynamicContentRenderer schema={pages} />
    </Container>
  );
};

export default PdfRootRenderer;
